export default __webpack_public_path__ + "static/media/DAIF_Eco_Screen1_in.b949e1d8.mp4";